module.exports = __webpack_public_path__ + "img/mail.19360e84.svg";